import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DateTime } from 'luxon';

// The Control Outlines card's body on the Test UI Components page (#6020): every input control and
// outlined button, so their resting outline ($border-secondary) and their hover / focus / error /
// disabled looks can be compared side by side. Hover, press, focus and disabled come from the one
// control-states mixin (#6031).
@Component({
  selector: 'cs-test-control-outlines-card',
  host: { class: 'showcase-card-body' },
  templateUrl: 'cs-test-control-outlines-card.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestControlOutlinesCardComponent {
  // the rest-state cs-input's text; the page shares it with the Layout card's cs-form-field
  @Input() sampleText = '';
  @Output() sampleTextChange = new EventEmitter<string>();
  // the input-calendar's date; the page shares it with the Calendar card's "Valid" field
  @Input() sampleDate: string | undefined;
  @Output() sampleDateChange = new EventEmitter<string>();

  readonly datePlaceholder = DateTime.local().minus({ year: 18 }).toISODate();
  outlineMeasure: number | undefined = undefined;
  outlineTime = '07:30';
  outlineSelect = 'a';
  outlineNotes = '';
  outlineSegment = 'week';
  outlineRadio = 'two';
  complexRadio = 'balanced';
  planRadio = 'yearly';
  tableRadio = 'barbell';
  outlineMarkdown = '**Bold**, _italic_ and a list:\n\n- one\n- two';
}
